import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { faAngleRight, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CircularProgress, Modal } from "@mui/material";
import { weekDays } from "src/lib/constans";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IAvailability } from "src/types/GlobalInterfaces";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import PrimaryBtn from "./GlobalComponents/primaryBtn";
import { useDispatch, useSelector } from "react-redux";
import { toogleHomeCareAppointementDrawer, tooglePleaseLogin } from "src/Store/reducer";
import GradientBtn, { IGradientBtnProps } from "./WebsiteComponents/GradientBtn";
import { RootState } from "src/Store/store";

interface IProps extends Partial<IGradientBtnProps> {
  id: string;
  index?: number;
  size?: "fit" | "full";
}

const BookHomeCareAppButton: React.FC<IProps> = ({ id, index, ButtonText = "Book Appointment", fontsizeBtn = "font-size-14px", fontfamilyBtn = "font-Poppins-Medium", size = "fit", ...props }) => {
  const dispatch = useDispatch();
  const { isLogged } = useSelector((store: RootState) => store.appReducer);
  return (
    <>
      <GradientBtn
        ButtonText={ButtonText}
        fontsizeBtn={fontsizeBtn}
        fontfamilyBtn={fontfamilyBtn}
        onPress={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();
          if (!isLogged) {
            return dispatch(tooglePleaseLogin(true));
          }
          if (id) {
            dispatch(toogleHomeCareAppointementDrawer(id));
          }
        }}
        {...props}
        id={index || index === 0 ? `book-appointment-${index + 1}` : ""}
        btnExtraStyle={{
          ...props.btnExtraStyle,
          ...(size === "full" && {
            width: "100%",
          }),
        }}
      />
    </>
  );
};

export default BookHomeCareAppButton;
